import React, { useState, useEffect } from "react";
import { ReactComponent as CheckMark } from "../icons/CheckGreen.svg";
import styles from "./ToastMessage.scss";



export function ToastMessage({ src, onClose, timeout, message }) {

  useEffect(() => {
    if(timeout) setTimeout(onClose, timeout)
  }, [])

  return (
    <div className={styles.toastContainer}>
      <CheckMark />
      <span className={styles.toastLabel}>
        {message}
      </span>
    </div>
  );
}
